import React, { useState, useEffect } from 'react';
import { Package, Eye, Calendar, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { professionalClientService } from '../../../services/professionalClientService';

const ShipmentsTab = ({ clientId }) => {
  const navigate = useNavigate();
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadShipments();
  }, [clientId]);

  const loadShipments = async () => {
    try {
      setLoading(true);
      const data = await professionalClientService?.getClientShipments(clientId);
      setShipments(data);
    } catch (error) {
      console.error('Error loading shipments:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const styles = {
      pending: 'bg-yellow-100 text-yellow-800',
      in_transit: 'bg-blue-100 text-blue-800',
      customs: 'bg-purple-100 text-purple-800',
      out_for_delivery: 'bg-orange-100 text-orange-800',
      delivered: 'bg-green-100 text-green-800',
      exception: 'bg-red-100 text-red-800'
    };
    const labels = {
      pending: 'En attente',
      in_transit: 'En transit',
      customs: 'Douane',
      out_for_delivery: 'En livraison',
      delivered: 'Livré',
      exception: 'Incident'
    };
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${styles?.[status] || styles?.pending}`}>
        {labels?.[status] || status}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
        <p className="ml-4 text-gray-600">Chargement des expéditions...</p>
      </div>
    );
  }

  if (shipments?.length === 0) {
    return (
      <div className="text-center py-12">
        <Package className="w-12 h-12 mx-auto mb-4 text-gray-400" />
        <p className="text-gray-600">Aucune expédition trouvée pour ce client</p>
      </div>
    );
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-900">Expéditions</h2>
        <p className="text-sm text-gray-600">{shipments?.length} expédition{shipments?.length > 1 ? 's' : ''}</p>
      </div>
      <div className="space-y-4">
        {shipments?.map((shipment) => (
          <div key={shipment?.id} className="border border-gray-200 rounded-lg p-4 hover:border-green-500 transition-colors">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <h3 className="font-medium text-gray-900">{shipment?.reference}</h3>
                  {getStatusBadge(shipment?.current_status)}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-gray-600">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4" />
                    <span>Créé le {new Date(shipment?.created_at)?.toLocaleDateString('fr-FR')}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <MapPin className="w-4 h-4" />
                    <span>{shipment?.receiver_city}, {shipment?.receiver_country}</span>
                  </div>
                </div>
              </div>
              <button
                onClick={() => navigate(`/admin/shipments/${shipment?.id}`)}
                className="inline-flex items-center px-3 py-1.5 text-sm text-green-600 hover:text-green-800 font-medium"
              >
                <Eye className="w-4 h-4 mr-1" />
                Voir
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShipmentsTab;